/**
 * Yazdırma ve paylaşma (PDF §14). Sunucu PDF'i üretir; PWA onu açar, kullanıcı tarayıcının/sistemin
 * yazdırma ekranını kullanır. Sessiz yazdırma yoktur.
 *   Bilgisayar: PDF yeni sekmede açılır ve yazdırma penceresi tetiklenir.
 *   Android/iPhone/iPad: PDF açılır; sistemin Paylaş → Yazdır / Dosyalara kaydet yolu kullanılır.
 */

async function fetchPdf(url: string): Promise<Blob> {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Rapor dosyası indirilemedi. Lütfen tekrar deneyin.');
  return res.blob();
}

export async function printPdf(url: string, jobName: string): Promise<void> {
  const blob = await fetchPdf(url);
  const objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const isTouch = navigator.maxTouchPoints > 0 && /android|iphone|ipad|ipod|macintosh/i.test(navigator.userAgent);
  if (!isTouch) {
    // masaüstü: gizli iframe içinde PDF'i yükleyip yazdırma penceresini aç
    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.src = objectUrl;
    frame.onload = () => {
      try {
        frame.contentWindow?.focus();
        frame.contentWindow?.print();
      } catch {
        window.open(objectUrl, '_blank', 'noopener');
      }
    };
    document.body.appendChild(frame);
    setTimeout(() => { frame.remove(); URL.revokeObjectURL(objectUrl); }, 120_000);
    return;
  }
  // mobil: PDF görüntüleyicide açılır; Yazdır seçeneği oradan
  const w = window.open(objectUrl, '_blank', 'noopener');
  if (!w) downloadBlob(objectUrl, `${jobName}.pdf`);
  setTimeout(() => URL.revokeObjectURL(objectUrl), 120_000);
}

export async function sharePdf(url: string, title: string): Promise<void> {
  const blob = await fetchPdf(url);
  const file = new File([blob], `${title}.pdf`, { type: 'application/pdf' });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ title, files: [file] });
    return;
  }
  const objectUrl = URL.createObjectURL(file);
  downloadBlob(objectUrl, file.name);
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}

function downloadBlob(objectUrl: string, name: string): void {
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
